import styles from './style.module.css';

interface IPosterPrint {
  coverImg?: string;
  logo?: string;
  color?: string;
  title?: string;
  description?: string;
  name?: string;
  qrCode?: string;
  isMgm?: boolean;
}

export function PosterPrint({
  coverImg,
  logo,
  color,
  title,
  description,
  name,
  qrCode,
  isMgm,
}: IPosterPrint) {
  return (
    <>
      <div className={styles.print}>
        <div className={styles.printBox} id="print">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            style={{ isolation: 'isolate' }}
            width={595.276}
            height={841.89}
            viewBox="0 0 595.276 841.89"
          >
            <defs>
              <clipPath id="a">
                <path d="M0 0h595.276v841.89H0z" />
              </clipPath>
            </defs>
            <g clipPath="url(#a)">
              <path fill="#FFF" d="M0 0h595.276v841.89H0z" />
              <g style={{ mixBlendMode: 'normal' }} opacity={0.2}>
                <path
                  d="M53.233 541h488.81a5.563 5.563 0 0 1 5.56 5.56v80.88a5.563 5.563 0 0 1-5.56 5.56H53.233a5.564 5.564 0 0 1-5.561-5.56v-80.88a5.564 5.564 0 0 1 5.561-5.56Z"
                  style={{
                    fill: 'none',
                    stroke: '#000',
                    strokeWidth: 1,
                    strokeLinecap: 'square',
                    strokeMiterlimit: 3,
                  }}
                />
              </g>
              <g style={{ mixBlendMode: 'normal' }} opacity={0.2}>
                <path
                  d="M58.787 444h477.702c6.134 0 11.114 4.98 11.114 11.114v62.02c0 6.134-4.98 11.114-11.114 11.114H58.787c-6.135 0-11.115-4.98-11.115-11.114v-62.02c0-6.134 4.98-11.114 11.115-11.114Z"
                  style={{
                    fill: 'none',
                    stroke: '#000',
                    strokeWidth: 1,
                    strokeLinecap: 'square',
                    strokeMiterlimit: 3,
                  }}
                />
              </g>
              <text
                x="50%"
                y="23.5rem"
                style={{
                  fontFamily: 'sans-serif',
                  fontWeight: 600,
                  fontSize: 20,
                  fontStyle: 'normal',
                  fill: '#000',
                  stroke: 'none',
                  dominantBaseline: 'middle',
                  textAnchor: 'middle',
                }}
              >
                {isMgm ? `${name} tem um` : `${name} tem uma`}
              </text>
              <text
                x="50%"
                y="25.5rem"
                style={{
                  fontFamily: 'sans-serif',
                  fontWeight: 400,
                  fontSize: 20,
                  fontStyle: 'normal',
                  fill: '#000',
                  stroke: 'none',
                  dominantBaseline: 'middle',
                  textAnchor: 'middle',
                }}
              >
                {isMgm ? 'convite para você' : 'recomendação para você'}
              </text>
              <g style={{ mixBlendMode: 'normal' }} opacity={0.2}>
                <path
                  d="M61.845 651H533.43c7.823 0 14.173 6.351 14.173 14.173v132.654c0 7.822-6.35 14.173-14.173 14.173H61.845c-7.822 0-14.173-6.351-14.173-14.173V665.173c0-7.822 6.351-14.173 14.173-14.173Z"
                  style={{
                    stroke: 'none',
                    fill: color,
                    strokeMiterlimit: 10,
                  }}
                />
              </g>
              <path
                d="M402.386 671.75h106.211a6.147 6.147 0 0 1 6.144 6.145v106.21a6.147 6.147 0 0 1-6.144 6.145H402.386a6.147 6.147 0 0 1-6.145-6.145v-106.21a6.147 6.147 0 0 1 6.145-6.145Z"
                style={{ stroke: 'none', fill: '#fff', strokeMiterlimit: 10 }}
              />
              <path
                d="M290.09 750.445V718.97c0-5.101 3.587-7.172 8.004-4.621l13.629 7.869 13.629 7.868c4.418 2.551 4.418 6.692 0 9.243l-13.629 7.869-13.629 7.868c-4.417 2.551-8.004.48-8.004-4.621Z"
                fill={color}
              />
              <path
                d="M309.378 750.445V718.97c0-5.101 3.586-7.172 8.004-4.621l13.629 7.869 13.629 7.868c4.418 2.551 4.418 6.692 0 9.243l-13.629 7.869-13.629 7.868c-4.418 2.551-8.004.48-8.004-4.621Z"
                fill={color}
                opacity={0.7}
              />
              <path
                d="M328.666 750.445V718.97c0-5.101 3.586-7.172 8.004-4.621l13.629 7.869 13.629 7.868c4.418 2.551 4.418 6.692 0 9.243l-13.629 7.869-13.629 7.868c-4.418 2.551-8.004.48-8.004-4.621Z"
                fill={color}
                opacity={0.2}
              />
              <text
                transform="translate(122.64 700.633) scale(1.189)"
                style={{
                  fontFamily: 'sans-serif',
                  fontWeight: 400,
                  fontSize: 12,
                  fontStyle: 'normal',
                  fill: '#000',
                  stroke: 'none',
                }}
              >
                Aponte a câmera
              </text>
              <text
                transform="translate(122.64 720.064) scale(1.189)"
                style={{
                  fontFamily: 'sans-serif',
                  fontWeight: 400,
                  fontSize: 12,
                  fontStyle: 'normal',
                  fill: '#000',
                  stroke: 'none',
                }}
              >
                do celular
              </text>
              <path
                d="M95.312 689.045c9.709 0 17.592 7.882 17.592 17.592 0 9.709-7.883 17.592-17.592 17.592-9.71 0-17.593-7.883-17.593-17.592 0-9.71 7.883-17.592 17.593-17.592Z"
                style={{
                  stroke: 'none',
                  fill: color,
                  strokeMiterlimit: 10,
                }}
              />
              <text
                transform="translate(89.968 713.1) scale(1.189)"
                style={{
                  fontFamily: 'sans-serif',
                  fontWeight: 600,
                  fontSize: 14,
                  fontStyle: 'normal',
                  fill: '#fff',
                  stroke: 'none',
                }}
              >
                1
              </text>
              <text
                transform="translate(122.64 760.436) scale(1.189)"
                style={{
                  fontFamily: 'sans-serif',
                  fontWeight: 400,
                  fontSize: 12,
                  fontStyle: 'normal',
                  fill: '#000',
                  stroke: 'none',
                }}
              >
                Deixe seu contato
              </text>
              <text
                transform="translate(122.64 779.867) scale(1.189)"
                style={{
                  fontFamily: 'sans-serif',
                  fontWeight: 400,
                  fontSize: 12,
                  fontStyle: 'normal',
                  fill: '#000',
                  stroke: 'none',
                }}
              >
                e pronto!
              </text>
              <path
                d="M95.312 748.848c9.709 0 17.592 7.883 17.592 17.592s-7.883 17.592-17.592 17.592c-9.71 0-17.593-7.883-17.593-17.592s7.883-17.592 17.593-17.592Z"
                style={{
                  stroke: 'none',
                  fill: color,
                  strokeMiterlimit: 10,
                }}
              />
              <text
                transform="translate(89.968 772.902) scale(1.189)"
                style={{
                  fontFamily: 'sans-serif',
                  fontWeight: 600,
                  fontSize: 14,
                  fontStyle: 'normal',
                  fill: '#fff',
                  stroke: 'none',
                }}
              >
                2
              </text>
              <text
                x="50%"
                y="29.5rem"
                style={{
                  fill: color,
                  stroke: 'none',
                  fontFamily: 'sans-serif',
                  fontWeight: 600,
                  fontSize: 20,
                  fontStyle: 'normal',
                  textAnchor: 'middle',
                  dominantBaseline: 'middle',
                }}
              >
                {title!.length > 40 ? `${title?.substring(0, 39)}...` : title}
              </text>
              <g style={{ mixBlendMode: 'normal' }} opacity={0.7}>
                <text
                  y="31.5rem"
                  x="50%"
                  style={{
                    fontFamily: 'sans-serif',
                    fontWeight: 600,
                    fontSize: 16,
                    fontStyle: 'normal',
                    fill: '#000',
                    stroke: 'none',
                    textAnchor: 'middle',
                    dominantBaseline: 'middle',
                  }}
                >
                  {description}
                </text>
              </g>
              <defs>
                <mask id="c">
                  <path
                    d="M407.638 683.319H504v96.362h-96.362v-96.362Z"
                    style={{
                      stroke: '#000',
                      fill: '#fff',
                      strokeMiterlimit: 10,
                    }}
                  />
                </mask>
                <mask id="b">
                  <path
                    d="M407.638 683.319H504v96.362h-96.362v-96.362Z"
                    style={{
                      stroke: '#000',
                      fill: '#fff',
                      strokeMiterlimit: 10,
                    }}
                  />
                </mask>
              </defs>
              <g mask="url(#c)">
                <image
                  width={800}
                  height={800}
                  transform="matrix(.12 0 0 .12 407.638 683.319)"
                  preserveAspectRatio="none"
                  xlinkHref={`${qrCode}`}
                />
              </g>
              <path fill="#fff" d="M0 0h595.276v334.843H0z" />
              <clipPath id="d">
                <path fill="#fff" d="M0 0h595.276v334.843H0z" />
              </clipPath>
              <g clipPath="url(#d)">
                <defs>
                  <mask id="f">
                    <path
                      d="M0 0h595.276v380.418H0V0Z"
                      style={{
                        stroke: '#000',
                        fill: '#fff',
                        strokeMiterlimit: 10,
                      }}
                    />
                  </mask>
                  <mask id="e">
                    <path
                      d="M0 0h595.276v380.418H0V0Z"
                      style={{
                        stroke: '#000',
                        fill: '#fff',
                        strokeMiterlimit: 10,
                      }}
                    />
                  </mask>
                </defs>
                <g mask="url(#f)">
                  <image
                    width="100%"
                    preserveAspectRatio="xMinYMin meet"
                    xlinkHref={`${coverImg}`}
                  />
                </g>
              </g>
              <defs>
                <mask id="h">
                  <path
                    d="M196.5 556.345h202.276v61.31H196.5v-61.31Z"
                    style={{
                      stroke: '#000',
                      fill: '#fff',
                      strokeMiterlimit: 10,
                    }}
                  />
                </mask>
                <mask id="g">
                  <path
                    d="M196.5 556.345h202.276v61.31H196.5v-61.31Z"
                    style={{
                      stroke: '#000',
                      fill: '#fff',
                      strokeMiterlimit: 10,
                    }}
                  />
                </mask>
              </defs>
              <g mask="url(#h)">
                <image
                  width={838}
                  height={254}
                  transform="matrix(.241 0 0 .241 196.5 556.345)"
                  preserveAspectRatio="xMinYMin meet"
                  xlinkHref={`${logo}`}
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </>
  );
}
